
// Action: file_editor create /app/frontend/src/pages/TestimonialsPage.js --file-text 
import React from 'react';
import Testimonials from '../components/Testimonials';

const TestimonialsPage = () => {
  return (
    <div data-testid="testimonials-page" className="pt-24">
      <Testimonials />
    </div>
  );
};

export default TestimonialsPage;

// Observation: Create successful: /app/frontend/src/pages/TestimonialsPage.js